module.exports = __webpack_public_path__ + "img/email-action-add.70c4bb9e.svg";